<template>
	<div class="com-list-content">
		<com-search :model="search" :transfer-model.sync="condition" v-slot="{data}" :table="$refs.table">
			<ui-select v-model="data.gradeId" label="年级" url="/admin/grade/list?page=1&limit=100" value-field="id" text-field="name"/>
			<ui-template>
				<ui-button type="search"></ui-button>
				<ui-button type="add" @click="add">增加</ui-button>
			</ui-template>
		</com-search>
		<com-table ref="table" url="/admin/textbook/list" :search="condition" v-slot="{data}">
			<ui-select v-model="data.gradeId" label="年级" url="/admin/grade/list?page=1&limit=100" value-field="id" text-field="name"/>
			<ui-select v-model="data.subject" label="科目">
				<ui-option value="1" text="语文" tag-type="success"/>
				<ui-option value="2" text="数学" tag-type="success"/>
				<ui-option value="3" text="英语" tag-type="success"/>
			</ui-select>
			<ui-text v-model="data.unit" label="单元"/>
			<ui-text v-model="data.section" label="章节"/>
			<ui-text v-model="data.sort" label="排序"/>
			<ui-text v-model="data.createTime" label="创建时间"/>
			<ui-template label="操作">
				<ui-button type="edit" @click="edit(data)"/>
				<ui-button type="delete" @click="remove(data)"/>
			</ui-template>
		</com-table>
	</div>
</template>

<script>
export default {
	data(){
		return {
			search:{},
			condition:{},
		};
	},
	mounted(){
	},
	methods:{
		add(){
			this.$dialog('textbook_detail',{type:'add',data:{}},()=>{
				this.$refs.table.refresh();
			})
		},
		edit(data){
			this.$dialog('textbook_detail',{type:'edit',data:data},()=>{
				this.$refs.table.refresh();
			})
		},
		page(data){
			this.$dialog('page_detail',{type:'edit',data:data},()=>{
				this.$refs.table.refresh();
			})
		},
		remove(data){
			this.$axios.delete('/admin/textbook/option/'+data.id)
			.then(data=>{
				this.$refs.table.refresh();
			}).end();
		}
	}
}
</script>

<style>
</style>
